import Splide from '@splidejs/splide';

class HeroSlider {
  constructor() {
    this.spliteOptions = {
      autoplay: true,
      autoHeight: false,
      autoWidth: false,
      arrows: true,
      clones: 0,
      interval: 5_000,
      keyboard: true,
      lazyLoad: 'nearby',
      pagination: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      perMove: 1,
      reducedMotion: {
        autoplay: false,
      },
      resetProgress: false,
      rewind: true,
      rewindSpeed: 500,
      type: 'loop',
      speed: 500,
      classes: {
        pagination: 'splide__pagination c-hero-slider__pagination',
        page: 'splide__pagination__page c-hero-slider__page',
      },
    };

    this.init = this.init.bind(this);
    this.init();
  }

  init() {
    new Splide('[data-hero-slider]', this.spliteOptions).mount();
  }
}
export default new HeroSlider();

